import {
	type ApplicationEdition,
	type ApplicationEditionKey,
	STANDARD_EDITION_KEY,
	PREMIUM_EDITION_KEY,
} from '@atlassian/jira-shared-types/src/edition.tsx';
import type { Environment } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

export const EDITION_KEY: Partial<Record<ApplicationEdition, ApplicationEditionKey>> = {
	STANDARD_EDITION: STANDARD_EDITION_KEY,
	PREMIUM_EDITION: PREMIUM_EDITION_KEY,
};
export const ADMIN_HUB_URL: Record<Environment, string> = {
	prod: 'https://admin.atlassian.com',
	dev: 'https://admin.stg.atlassian.com',
	local: 'https://admin.stg.atlassian.com',
	staging: 'https://admin.stg.atlassian.com',
} as const;
